module.exports = __webpack_public_path__ + "img/office365.c5537a16.png";